import React, { Fragment, useContext, useEffect, useState } from "react";
import WarrantyList from "./WarrantyList";
import { observer } from "mobx-react-lite";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { RootStoreContext } from "../../../app/stores/rootStore";
import TextInput from "../../../app/common/form/TextInput";
import SelectInput from "../../../app/common/form/SelectInput";
import { category } from "../../../app/common/options/brandOptions";
import DateInput from "../../../app/common/form/DateInput";
import { Segment, Form, Button, Header, Icon, Divider } from "semantic-ui-react";
import { Form as FinalForm, Field } from "react-final-form";
import {
  WarrantySearchFormValues,
} from "../../../app/models/warranty";
import Swal from 'sweetalert2';
const WarrantyDashboard: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {
    loadWarranties,
    loadingInitial,
    brand,
    setBrand,
    setFilter,
    clearWarrantyData,
    setShowWarrantyDetail
  } = rootStore.warrantyStore;
  const [activity, setActivity] = useState(new WarrantySearchFormValues());
  const [loading] = useState(false);
  const [loadingNext, setLoadingNext] = useState(false);

  const handleFinalFormSubmit = (values: any) => {
    setLoadingNext(true);
    setShowWarrantyDetail(false);
    
    const { date, time, ...activity } = values;

    //Check if brand value change
    if (brand !== values.brand) {
      setBrand(values.brand);
      setActivity(activity);

      clearWarrantyData();
      loadWarranties().then(() => setLoadingNext(false));
    }
    setFilter(values);
    setLoadingNext(false);
  };

 

  useEffect(() => {
    loadWarranties();
    
  }, [loadWarranties]);

  //if (loadingInitial) return <LoadingComponent content="Loading warranties" />;
  //if (loadingInitial) return <LoadingComponent content="Loading warranties" />;
  if (loadingInitial){
    
    let timerInterval :any
Swal.fire({
  title: 'Loading Warrenties',
  
  timer: 2000,
  timerProgressBar: true,
  willOpen: () => {
    Swal.showLoading()
    timerInterval = setInterval(() =>  100)
  },
  onClose: () => {
    clearInterval(timerInterval)
  }
}).then((result) => {
  /* Read more about handling dismissals below */
  if (result.dismiss === Swal.DismissReason.timer) {
    console.log('I was closed by the timer')
  }
})

  }
  

  return (
    <Fragment>
      <Divider fitted hidden />
      <Header as='h3' attached='top'>
      <Icon name='filter' />
        <Header.Content>Search Fields</Header.Content>
      </Header>
      <Segment attached color='blue' clearing>
        <FinalForm
          initialValues={activity}
          onSubmit={handleFinalFormSubmit}
          render={({ handleSubmit, invalid, pristine, form }) => (
            <Form onSubmit={handleSubmit} loading={loading}>
              <Form.Group widths="equal">
                <Field
                  component={SelectInput}
                  options={category}
                  name="brand"
                  placeholder="Brand"
                  value={activity.brand}
                />
                <Field
                  name="firstName"
                  placeholder="First Name"
                  value={activity.firstName}
                  component={TextInput}
                />
                <Field
                  name="lastName"
                  placeholder="Last Name"
                  value={activity.lastName}
                  component={TextInput}
                />
                <Field
                  name="sku"
                  placeholder="SKU"
                  value={activity.sku}
                  component={TextInput}
                />
                  <Field
                  component={DateInput}
                  name="registrationDateFrom"
                  date={true}
                  placeholder="Registration Date From"
                  value={activity.registrationDateFrom}
                />
                <Field
                  component={DateInput}
                  name="registrationDateTo"
                  date={true}
                  placeholder="Registration Date To"
                  value={activity.registrationDateTo}
                />
              </Form.Group>
              <Form.Group>
              
              <Button icon labelPosition='right'
                disabled={loading || invalid || pristine}
                floated="right"
                primary
                type="submit"
          
                loading={loadingNext}
              ><Icon name='search' />Search</Button>
                
              
              <Button icon labelPosition='right'
                 onClick={() => {
                  form.reset();
                  console.log(WarrantySearchFormValues);
                  window.location.reload();

                }}
                disabled={loading}
                floated="right"
                type="Cancel"
          
              ><Icon name='redo' />Reset</Button>
             
              </Form.Group>
            </Form>
          )}
        />
      </Segment>
      <br />
      
      <Header as='h3' attached>
      <Icon name='list' />
        <Header.Content>Warranties Registration List</Header.Content>
      </Header>
      <Segment attached color='teal'>
      <WarrantyList/>
      </Segment>
    </Fragment>
  );
};

export default observer(WarrantyDashboard);
